import { render } from "./TemplateSheet.vue?vue&type=template&id=f6df0410"
import script from "./TemplateSheet.vue?vue&type=script&lang=js"
export * from "./TemplateSheet.vue?vue&type=script&lang=js"
script.render = render

export default script